import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { mostrarModulo, actualizarMensaje } from "../../../redux/actions/actGlobal";
import { Paper, Grid, Box, DialogActions, DialogContent, Dialog, TextField, List, ListItem, ListItemText, Link } from '@material-ui/core'
import { consulta, rutaImg, obtenerValoresFiltros, mostrarError, crear_form_data, formulario } from "../../../global/js/funciones";
import { BtnDetalle, BtnPermiso, BtnForm, BtnRegresar, BtnFolder } from "../../general/BotonesAccion";
import ListarDatos from "./../../general/ListarDatos";
import AppBarModal from "./../../general/AppBarModal";
import Generica from "./../../personas/generica/Generica";
import TareasTerminadas from "../../general/TareasTerminadas";
import emma_w from '../../../global/imagenes/emma_w.png';
import AccionesRapidas from '../../general/AccionesRapidas';
import TituloAccion from '../../general/TituloAccion';
import { ESTADOS_INSCRIPCIONES, TIPO_INSCRIPCIONES } from '../helper';
import fechaIcon from '../../../global/imagenes/calendar.png';
import permisosIcon from '../../../global/imagenes/lightbulb.png';
import librespregrado from '../../../global/imagenes/librespregrado.png'
import icono_excel from '../../../global/imagenes/icono_excel.png'
import exportar_inscripciones from '../../../global/imagenes/exportar_inscripciones.png'
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { mostrarModalPeriodoActualizarInscripcion } from "../../../redux/actions/actInscripciones";
import Genericas from "../../genericas/Genericas"
import { COLEGIOS_PREUNIVERSITARIO, CALIFICACION_CONTACTO, LINEAEDU, COSTEAR_ESTUDIOS } from '../helper';
import BuscarSelect from '../../general/BuscarSelect';
import EnviarArchivo from '../../general/EnviarArchivo';
import * as XLSX from 'xlsx';



function ActualizarPeriodo(component_props) {
  let {
    mostrarModalPeriodoActualizarInscripcion,
    modalPeriodoActualizarInscripcion,
    periodo_actualizar,
    fecha_periodo,
    enviarDatos,
    onChange,
    onChangeFecha,
    changeState,
    tipo_inscripcion_seleccionado,
    setSelect_value,
    años,
    periodos,
    periodo_seleccionado,
    opciones_tipo_inscripcion,
    periodo_inscripciones,
    periodo_educo,
  } = component_props

  return (
    <Dialog open={modalPeriodoActualizarInscripcion} maxWidth='xs' fullWidth={true} onClose={mostrarModalPeriodoActualizarInscripcion.bind(this, false)}>
      <AppBarModal titulo='¡ Actualizar Periodo !' mostrarModal={mostrarModalPeriodoActualizarInscripcion} titulo_accion='' />
      <DialogContent style={{ padding: 0 }} className='scroll' >
        <Paper elevation={0} square style={{ boxShadow: 'none', backgroundColor: 'transparent' }}>
          <Box px={2} pb={1}>
            <Box py={2} style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.08)' }}>
              <BuscarSelect
                datos={opciones_tipo_inscripcion}
                cambiarEstado={(value) => setSelect_value('tipo_inscripcion_seleccionado', value)}
                valor={tipo_inscripcion_seleccionado}
                id='select-inscripcion'
                nombre='Seleccionar Inscripcion'
                placeholder='Seleccione Modulo'
              />
            </Box>
            <Box py={2} style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.08)' }}>
              <TextField
                style={{ width: '100%', margin: 0 }}
                id="periodo_actual"
                label="Periodo"
                value={tipo_inscripcion_seleccionado ? tipo_inscripcion_seleccionado.value === 'Per_Edu' ? periodo_educo : periodo_inscripciones : ""}
                onChange={(e) => { changeState((tipo_inscripcion_seleccionado.value === 'Per_Edu' ? 'periodo_educo' : 'periodo_inscripciones'), e.target.value) }}
              />
            </Box>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Box pt={1} pb={1}>
                <KeyboardDatePicker
                  margin="normal"
                  id="fecha_periodo"
                  format="yyyy/MM/dd"
                  value={fecha_periodo}
                  fullWidth
                  onChange={onChangeFecha}
                />
              </Box>
            </MuiPickersUtilsProvider>
          </Box>
        </Paper>
      </DialogContent>
      <DialogActions>
        <BtnForm texto="Aceptar" callback={() => enviarDatos()} />
        <BtnForm texto="Cerrar" callback={() => mostrarModalPeriodoActualizarInscripcion(false)} />
      </DialogActions>
    </Dialog>
  )
}

// Modal para exportar inscripciones por periodo
function ModalExportarInscripciones(props) {
  let { setModalExportarInscripciones, modalExportarInscripciones, periodos, periodo_exportar, setPeriodo, actualizarMensaje, cargando, setCargando, periodo_inscripciones, valor } = props

  const exportar_excel_inscripciones = async (periodo_exportar) => {
    setCargando(true);
    try {
      if (!periodo_exportar) {
        actualizarMensaje({ titulo: 'Seleccione un periodo', tipo: 'info', mostrar: true, tiempo: 6000 });
        setCargando(false);
        return;
      }
      let inscripciones = await obtenerInscripciones(periodo_exportar.label);
      if (inscripciones.length == 0) {
        actualizarMensaje({ titulo: 'No hay inscripciones para exportar', tipo: 'info', mostrar: true, tiempo: 6000 });
        setCargando(false);
        return;
      }
      const titulo_informe = `INSCRIPCIONES_${periodo_exportar.label}`;

      const columnas = [
        { title: 'NO. IDENTIFICACION', field: 'identificacion', orden: 1 },
        { title: 'TIPO_IDENTIFICACION', field: 'tipo_identificacion', orden: 2 },
        { title: 'NATURALEZA', field: 'naturaleza', orden: 3 },
        { title: 'PRIMER_NOMBRE', field: 'primer_nombre', orden: 4 },
        { title: 'SEGUNDO_NOMBRE', field: 'segundo_nombre', orden: 5 },
        { title: 'PRIMER_APELLIDO', field: 'primer_apellido', orden: 6 },
        { title: 'SEGUNDO_APELLIDO', field: 'segundo_apellido', orden: 7 },
        { title: 'GENERO', field: 'genero', orden: 8 },
        { title: 'FECHA_NACIMIENTO', field: 'fecha_nacimiento', orden: 9 },
        { title: 'ESTADO_CIVIL', field: 'estado_civil', orden: 10 },
        { title: 'NACIONALIDAD', field: 'nacionalidad', orden: 11 },
        { title: 'DIR_RESIDENCIA', field: 'direccion', orden: 12 },
        { title: 'CORREO_ELECTRONICO_PERSONAL', field: 'correo_personal', orden: 13 },
        { title: 'TEL_RESIDENCIA', field: 'telefono1', orden: 14 },
        { title: 'MOVIL', field: 'celular1', orden: 15 },
        { title: 'CIUDAD_RESIDENCIA', field: 'lugar_residencia', orden: 16 },
        { title: 'CIUDAD_NACIMIENTO', field: 'lugar_nacimiento', orden: 17 },
        { title: 'LIBRETA_MILITAR', field: 'libreta_militar', orden: 18 },
        { title: 'DISTRITO', field: 'distrito', orden: 19 },
        { title: 'CIUDAD_DOCUMENTO', field: 'ciudad__nombre', orden: 20 },
        { title: 'FECHA_DOCUMENTO', field: 'fecha_expedicion', orden: 21 },
        { title: 'EPS', field: 'eps', orden: 22 },
        { title: 'ESTRATO', field: 'estrato__nombre', orden: 23 },
        { title: 'USUARIO ACTIVE DIRECTORY', field: 'usuario_active_directory', orden: 24 },
        { title: 'CORREO_ELECTRONICO_INSTITUCIONAL', field: 'correo', orden: 25 },
        { title: 'PROGRAMA', field: 'nombre_carrera', orden: 26 },
        { title: 'CODIGO_PROGRAMA', field: 'codigo_programa', orden: 27 },
        { title: 'FECHA_REGISTRO', field: 'fecha_registro', orden: 28}
      ];

      columnas.sort((a, b) => a.orden - b.orden);
      
      const datos = inscripciones.map(inscripcion => {
        const fila = {};
        columnas.forEach(columna => fila[columna.field] = inscripcion[columna.field]);
        return fila;
      });

      const titulos = columnas.map((columna) => columna.title);

      const workbook = XLSX.utils.book_new();

      const worksheet = XLSX.utils.aoa_to_sheet([titulos, ...datos.map((item) => Object.values(item))]);

      const wscols = columnas.map(() => ({ wch: 20 }));
      worksheet['!cols'] = wscols;

      XLSX.utils.book_append_sheet(workbook, worksheet, 'Inscripciones');

      const fecha = new Date();

      const nombreArchivo = `${titulo_informe}_${fecha.toISOString().slice(0, 10)}, ${fecha.getHours()}-${fecha.getMinutes()}.xlsx`;

      XLSX.writeFile(workbook, nombreArchivo);

      actualizarMensaje({ titulo: 'Archivo generado correctamente', tipo: 'success', mostrar: true, tiempo: 6000 });

    } catch (error) {
      console.error('Este es el error al exportar el excel: ', error);
      actualizarMensaje({
        titulo: 'Error al generar el archivo Excel',
        tipo: 'error',
        mostrar: true,
        tiempo: 6000
      });
    }
    setCargando(false);
  }

  const obtenerInscripciones = async (periodo) => {
    return new Promise(resolve => {
      consulta(`api/v1.0/inscripciones/exportar_inscripciones?&estado_actual__codigo=Ins_Reg&periodo=${periodo}&tipoInscripcion=Tipo_Ins`, null, null, (error, estado, resp) => {
        resolve(estado === 200 && !error ? resp : null);
      })
    })
  }

  // periodos = periodos.sort((a, b) => a.label.localeCompare(b.label));
  periodos = periodos.filter(p => p.label === periodo_inscripciones);

  return (
    <Dialog open={modalExportarInscripciones} maxWidth='xs' fullWidth={true} onClose={setModalExportarInscripciones.bind(this, false)}>
      <AppBarModal titulo='¡ Exportar Inscripciones !' mostrarModal={setModalExportarInscripciones} titulo_accion='' />
      <DialogContent style={{ padding: 0 }} className='scroll' >
        <Grid container className='margin_cont' style={{ justifyContent: 'center' }}>
          {cargando ? <TareasTerminadas mensaje='Cargando..' marginTop='7%' imagen={emma_w} widthImg="7%" cargando={true} /> :
            <>
              <a href={`${valor.archivo}`} target='_black' className='sin_decorador' style={{ color: '#B70E0C', marginTop: '20px' }}>Clic aquí para descargar plantilla!</a>
              <Grid item xs={9} style={{ 'marginBottom': '40px', 'marginTop': '20px' }}>
                <BuscarSelect datos={periodos} cambiarEstado={setPeriodo} id='select-periodo' valor={periodo_exportar} nombre='Periodos' placeholder='Seleccione el periodo' />
              </Grid>
            </>
          }
        </Grid>
      </DialogContent>
      <DialogActions>
        <BtnForm texto="Exportar" callback={() => exportar_excel_inscripciones(periodo_exportar)} />
        <BtnForm texto="Cerrar" callback={() => { setModalExportarInscripciones(false) }} />
      </DialogActions>
    </Dialog>
  )
}


class InscripcionesPermisos extends Component {
  constructor(props) {
    super(props)
    this.state = {
      cargando: true,
      personas: [],
      generica: {
        tipo: 0,
        id: 0,
      },
      modal: false,
      id_persona: null,
      periodo_actualizar: '',
      fecha_periodo: '',
      accionProceso: 'inicio',
      accion: 'procesos',
      periodo: [],
      tipo_inscripcion_seleccionado: null,
      opciones_tipo_inscripcion: [
        {
          value: 'Per_Edu',
          label: 'Inscripciones EDU.co',
        },
        {
          value: 'Per_Ins',
          label: 'Inscripciones',
        }
      ],
      periodos: [],
      años: [],
      periodo_inscripciones: "",
      periodo_educo: "",
      periodo_seleccionado: null,
      setSelect_value: (key, value) => {
        this.changeState(key, value)
      },
      openModalCargarExcel: false,
      setModalCargarExcel: (value) => {
        this.setState({ openModalCargarExcel: value })
      },
      masivo: '',
      openModalExportarInscripciones: false,
      setModalExportarInscripciones: (value) => {
        this.setState({ openModalExportarInscripciones: value })
      },
      periodo_exportar: '',
      cargando_modal: false,
      valor: {},
    }
  }

  changeState = (name, value) => {
    this.setState({
      [name]: value
    })
  }

  async obtenerPeriodos(tipo) {
    return new Promise(resolve => {
      consulta(`api/v1.0/inscripciones/periodos/${tipo}`, null, null,
        (error, estado, resp) => {
          resolve(resp)
        }
      );
    })
  }

  async componentDidMount() {
    let personas = await this.obtenerGestores();
    let periodo = await obtenerValoresFiltros([{ 'llave': 'codigo', 'valor': 'Per_Ins' }, { 'llave': 'estado', 'valor': '1' }]);
    let periodos = await this.obtenerPeriodos(1)
    let años = await this.obtenerPeriodos(2)
    let periodo_inscripciones = await obtenerValoresFiltros([{ llave: 'codigo', valor: 'Per_Ins' }])
    let periodo_educo = await obtenerValoresFiltros([{ llave: 'codigo', valor: 'Per_Edu' }])
    this.setState({ periodo_inscripciones: periodo_inscripciones[0].nombre, periodo_educo: periodo_educo[0].nombre, periodos: this.transformarEnviadoPeriodos(periodos), años: this.transformarEnviadoPeriodos(años), personas, cargando: false, periodo, periodo_actualizar: periodo[0].nombre, fecha_periodo: periodo[0].valora })
    let masivo = await obtenerValoresFiltros([{ 'llave': 'codigo', 'valor': 'insc_xlsx' }, { 'llave': 'estado', 'valor': '1' }]);
    this.setState({ masivo: masivo[0] });
    let valores = await obtenerValoresFiltros([{ 'llave': 'codigo', 'valor': 'sicu_insc_plan' }]);
    this.setState({ valor: valores[0] });
  }

  transformarEnviadoPeriodos(data) {
    return data.map((e, index) => ({
      value: index,
      label: e.periodo,
      codigo: e.periodo,
    }));
  }

  async obtenerGestores() {
    return new Promise(resolve => {
      consulta(`api/v1.0/inscripciones/gestores`, null, null, (error, estado, resp) => {
        resolve(estado === 200 && !error ? resp : null);
      })
    })
  }



  onChangeFecha = (date) => {
    this.setState({ fecha_periodo: date })
  }
  onChange = ({ target }) => {
    let { value, name } = target;
    this.setState({
      [name]: value
    })
  }

  enviarDatos = (info) => {
    let { fecha_periodo, periodo_actualizar, tipo_inscripcion_seleccionado, periodo_seleccionado, periodo_inscripciones, periodo_educo } = this.state;
    let { actualizarMensaje } = this.props;
    let error = false
    periodo_seleccionado = tipo_inscripcion_seleccionado.value === 'Per_Edu' ? periodo_educo : periodo_inscripciones
    if (!fecha_periodo || !periodo_seleccionado || !tipo_inscripcion_seleccionado) { error = true }
    if (!error) {
      let data = {
        fecha: moment(fecha_periodo).format('YYYY-MM-DD'),
        periodo_actualizar: periodo_seleccionado,
        tipo_inscripcion: tipo_inscripcion_seleccionado.value,
      }
      this.guardarDatos(data)
      this.setState({ periodo_seleccionado, fecha_periodo })

    }
    else { actualizarMensaje({ titulo: 'Los Campos son obligatorios', tipo: 'info', mostrar: true, tiempo: 6000 }); }
  }

  guardarDatos = async (data) => {
    let { actualizarMensaje, mostrarModalPeriodoActualizarInscripcion } = this.props;
    return new Promise(resolve => {
      consulta(`api/v1.0/inscripciones/actualizar/fechaPeriodo`, data, "post", (error, estado, resp) => {
        let titulo = 'Ha ocurrido un error, contacte con el administrador.', tipo = 'error';
        if (!error) {
          if (estado === 200) {
            tipo = 'success';
            titulo = resp.titulo;
            mostrarModalPeriodoActualizarInscripcion(false);

          } else {
            tipo = 'info';
            titulo = resp.titulo ? resp.titulo : mostrarError(resp);
          }
        }
        actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 });
        resolve(estado === 200 && !error ? resp : null);

      })
    })
  }

  renderProcesos() {
    let { accionProceso } = this.state;
    return (
      <>
        {accionProceso === 'inicio' ? this.pintarInicioProcesos() : this.renderPracticas()}
        {accionProceso !== 'inicio' && <div className={'regresar'} ><BtnRegresar callback={() => this.setState({ accionProceso: 'inicio' })} /></div>}
      </>
    )
  }

  acciones(data) {
    const onClickPrograma = (data) => this.setState({ id_persona: data.id, modal: true, generica: { tipo: 11, id: 5 } });
    const onClickEstado = (data) => this.setState({ id_persona: data.id, modal: true, generica: { tipo: 12, id: ESTADOS_INSCRIPCIONES } });
    const onClickTipoInscripcion = (data) => this.setState({ id_persona: data.id, modal: true, generica: { tipo: 28, id: TIPO_INSCRIPCIONES } });
    let tipos = <BtnFolder callback={() => onClickTipoInscripcion(data)} texto='Tipo Inscripcion' />;
    let programa = <BtnDetalle callback={() => onClickPrograma(data)} texto='Programas' color='#2196f3' />;
    let estados = <BtnPermiso callback={() => onClickEstado(data)} texto='Estados' />;
    return <div>{tipos}{programa} {estados}</div>
  }

  pintarInicioProcesos() {
    let {
      periodo,
      periodo_actualizar,
      fecha_periodo,
      tipo_inscripcion_seleccionado,
      opciones_tipo_inscripcion,
      setSelect_value,
      años,
      periodos,
      periodo_seleccionado,
      periodo_inscripciones,
      periodo_educo,
      masivo,
      valor,
    } = this.state;
    let { modalPeriodoActualizarInscripcion, mostrarModalPeriodoActualizarInscripcion } = this.props
    return (
      <div style={{ padding: '2% 2% 0% 2%' }} >
        <Grid container direction={'row'} spacing={1} justify={'center'} >
          <Grid item xs={12} sm={12} md={10} lg={8} >
            <TituloAccion principal='' alterno='¿ Que deseas hacer ?' />
            <Paper elevation={0} square className="scroll contenido_fijo">
              <Grid container direction={'row'} spacing={1} style={{ width: "100%" }}>
                <Grid item xs={12} sm={12} md={6} lg={6} >
                  <Paper elevation={1} style={{ border: '1px solid #e0e0e0' }} onClick={() => mostrarModalPeriodoActualizarInscripcion(true)}>
                    <AccionesRapidas imagen={fechaIcon} titulo={`¡ Actualizar Período !`} sub_titulo='' des_sub_titulo={`Actualiza la fecha y el periodo lectivo.`} />
                  </Paper>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} >
                  <Paper elevation={1} style={{ border: '1px solid #e0e0e0' }} onClick={() => this.setState({ accionProceso: 'permisos' })}>
                    <AccionesRapidas imagen={permisosIcon} titulo='¡ Controlar Permisos !' sub_titulo='' des_sub_titulo='Verifica, asigna y retira permisos a los gestores.' />
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} >
                  <Paper elevation={1} style={{ border: '1px solid #e0e0e0' }} onClick={() => this.setState({ accionProceso: 'adminpreuni' })}>
                    <AccionesRapidas imagen={librespregrado} titulo='¡ Administrar listas EDU.co !' sub_titulo='' des_sub_titulo='Agrega, Modifica y Elimina datos.' />
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} >
                  <Paper elevation={1} style={{ border: '1px solid #e0e0e0' }} onClick={() => this.setState({ openModalCargarExcel: true })}>
                    <AccionesRapidas imagen={icono_excel} titulo='¡ Cargar estudiantes !' sub_titulo='' des_sub_titulo='Agrega estudiantes mediante un excel.' />
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} >
                  <Paper elevation={1} style={{ border: '1px solid #e0e0e0' }} onClick={() => this.setState({ openModalExportarInscripciones: true })}>
                    <AccionesRapidas imagen={exportar_inscripciones} titulo='¡ Exportar inscripciones !' sub_titulo='' des_sub_titulo='Exporta el listado de inscripciones por periodo.' />
                  </Paper>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
        <ActualizarPeriodo
          {...{
            modalPeriodoActualizarInscripcion,
            mostrarModalPeriodoActualizarInscripcion,
            periodo_actualizar,
            tipo_inscripcion_seleccionado,
            opciones_tipo_inscripcion,
            setSelect_value,
            años,
            periodo_inscripciones,
            periodo_educo,
            periodos,
            periodo_seleccionado,
            fecha_periodo,
            changeState: this.changeState,
            onChange: this.onChange,
            onChangeFecha: this.onChangeFecha,
            enviarDatos: this.enviarDatos
          }}
        />
        <EnviarArchivo modalAdd={this.state.openModalCargarExcel} mostrarModalAdd={this.state.setModalCargarExcel} titulo='Cargar excel' id='adj_archivo' name='adj_archivo' label='Adjuntar Archivo' formatos='Excel' mensaje={
          <Grid>
            Tenga en cuenta las siguientes indicaciones:
            <List dense={true}>
              <ListItem>
                <ListItemText
                  primary={
                    <Link
                      target="_blank"
                      underline='none'
                      href={masivo.archivo}
                      style={{ color: '#B22222', textDecoration: 'none' }}
                    >
                      ¡Haga clic para descargar la plantilla y registrar los datos de los participantes!
                    </Link>
                  }
                />
              </ListItem>
              <ListItem>
                <ListItemText primary='No realice cambios en el formato de la plantilla.' />
              </ListItem>
            </List>
          </Grid>
        } enviarArchivo={(archivo) => this.enviarExcel(archivo)} />
        <ModalExportarInscripciones
          {...{
            modalExportarInscripciones: this.state.openModalExportarInscripciones,
            setModalExportarInscripciones: this.state.setModalExportarInscripciones,
            periodos: this.state.periodos,
            setPeriodo: (e) => { 
              this.setState({ periodo_exportar: e })
            },
            periodo_exportar: this.state.periodo_exportar,
            actualizarMensaje: this.props.actualizarMensaje,
            cargando: this.state.cargando_modal,
            setCargando: (cargando_modal) => { this.setState({ cargando_modal }) },
            periodo_inscripciones: this.state.periodo_inscripciones,
            valor: valor,
          }}
        />
      </div>
    )
  }

  renderPermisosInscripcion = () => {
    let { modal, id_persona, generica, personas } = this.state;
    return (
      <>
        <ListarDatos
          datos={personas}
          titulo='Lista Gestores'
          buscar={true}
          agregar={false}
          opciones={true}
          descargar='EMMA - GESTORES INSCRIPCIONES'
          id='tbl_gestores_ins'
          acciones={row => this.acciones(row)}
          avatarImg={true}
          avatar={({ identificacion }) => `${rutaImg}${identificacion}.jpg`}
          fila_principal={({ primer_nombre, primer_apellido, segundo_apellido }) => `${primer_nombre} ${primer_apellido} ${segundo_apellido}`}
          filas={[
            { 'id': 'nombre', 'mostrar': ({ primer_nombre, primer_apellido, segundo_apellido }) => `${primer_nombre} ${primer_apellido} ${segundo_apellido}`, 'enLista': false },
            { 'id': 'correo' },
            { 'id': 'identificacion' },
          ]}
        />

        <Dialog open={modal} fullWidth={true} maxWidth='sm' onClose={() => this.setState({ modal: false })}>
          <AppBarModal titulo='¡ Lista Permisos !' mostrarModal={() => this.setState({ modal: false })} accion={() => this.setState({ modal: false })} titulo_accion='CERRAR' />
          <DialogContent style={{ padding: 0 }} className='scroll'>
            <Generica tipo={generica.tipo} persona={{ id: id_persona }} genericaRelacionId={generica.id} titulo="¡ Nuevo Permiso !" tituloInput="Permisos" tituloEliminar='¿ Eliminar Permiso ?' />
          </DialogContent>
          <DialogActions>
            <BtnForm texto="Cerrar" callback={() => this.setState({ modal: false })} />
          </DialogActions>
        </Dialog>
      </>
    )
  }

  renderProcesos() {
    let { accionProceso } = this.state;
    let dato = [COLEGIOS_PREUNIVERSITARIO, CALIFICACION_CONTACTO,
      LINEAEDU, COSTEAR_ESTUDIOS]// Se envia para que pueda agregar y modificar las listas
    return (
      <>
        {accionProceso === 'inicio' && this.pintarInicioProcesos()}
        {accionProceso === 'permisos' && this.renderPermisosInscripcion()}
        {accionProceso === 'adminpreuni' && <Genericas {...{ busquedaFija: true, idGenerica: dato }} />}
        {accionProceso !== 'inicio' && <div className={'regresar'} ><BtnRegresar callback={() => this.setState({ filtros_practica: [], accionProceso: 'inicio' })} /></div>}
      </>
    )
  }

  pintar = () => {
    let { cargando, accion } = this.state;
    return (
      <>
        {!cargando ?
          <div >
            {accion === 'procesos' && this.renderProcesos()}
          </div>
          : <TareasTerminadas imagen={emma_w} mensaje='Cargando..' widthImg='7%' marginTop='7%' cargando={true} />
        }
      </>
    )
  }

  enviarExcel = async (archivo) => {
    this.setState({ cargando: true });
    let { actualizarMensaje } = this.props;
    let formdata = new FormData();
    formdata.append('archivo', archivo);
    if (!archivo) {
      actualizarMensaje({ titulo: 'Debe seleccionar un archivo', tipo: 'info', mostrar: true, tiempo: 6000 });
      return;
    }
    formulario('api/v1.0/inscripciones/cargar_excel_estudiantes', formdata, 'post', (error, estado, resp) => {
      let titulo = 'Ha ocurrido un error, contacte con el administrador.', tipo = 'error';
      if (!error) {
        if (estado === 200) {
          tipo = 'success';
          titulo = resp.titulo;
          this.state.setModalCargarExcel(false)
        } else {
          tipo = 'info';
          titulo = resp.titulo ? resp.titulo : mostrarError(resp);
        }
      }
      this.setState({ cargando: false });
      actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 });
    });
  }

  render() {
    let { cargando } = this.state;
    if (cargando) return <TareasTerminadas mensaje='Cargando..' marginTop='7%' imagen={emma_w} widthImg="7%" cargando={true} />;
    return (
      <>
        {this.pintar()}
      </>
    )
  }
}

const mapStateToProps = (state) => {
  let { modalPeriodoActualizarInscripcion } = state.redInscripciones;
  let { usuario } = state.redGlobal;
  return {
    modalPeriodoActualizarInscripcion,
  }
};

const mapDispatchToProps = {
  actualizarMensaje,
  mostrarModalPeriodoActualizarInscripcion,
}

InscripcionesPermisos.propTypes = {
  mostrarModalPeriodoActualizarInscripcion: PropTypes.func.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(InscripcionesPermisos);